import styled from 'astroturf/react'
const colorError = 'var(--color-error, #C84545)'
const primaryColor = 'var(--primary-color, rgb(0, 105, 255))'
const textColorLevel2 = 'var(--text-color-level2, rgba(26, 26, 26, 0.61))'
import { Icon as CoreIcon } from '@calendly/ui/components/icon'
import _Input from "styles-Input.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/form/inputs/checkbox/styles.js?styleId=Input";
import _Body from "styles-Body.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/form/inputs/checkbox/styles.js?styleId=Body";
import _Container from "styles-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/form/inputs/checkbox/styles.js?styleId=Container";
import _Icon from "styles-Icon.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/form/inputs/checkbox/styles.js?styleId=Icon";


const size = '16px'
const fontSize = '9px'

export const Input = /*#__PURE__*/styled('input', null, {
  displayName: "Input",
  styles: _Input,
  attrs: props => ({
    ...props,
    type: 'checkbox'
  })
})

export const Body = /*#__PURE__*/styled('div', null, {
  displayName: "Body",
  styles: _Body
})

export const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container
})

export const Icon = /*#__PURE__*/styled(CoreIcon, null, {
  displayName: "Icon",
  styles: _Icon,
  attrs: props => ({
    ...props,
    name: 'checkmark'
  })
})
